/** Keep in sync with `$screenHeaderNav` / `@include media(header-nav)` in `assets/css/var.scss`. */
export const HEADER_NAV_MAX_WIDTH_PX = 920

export function useHeaderMobileLayout() {
  return useMediaQuery(`(max-width: ${HEADER_NAV_MAX_WIDTH_PX}px)`)
}
